import { Modal, ModalProps } from '../Modal/Modal.component';
import { CancelButton } from '../buttons/CancelButton.component';
import { ConfirmButton } from '../buttons/ConfirmButton.component';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { styles } from './ModalWithButtons.styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface ModalWithButtonsProps extends ModalProps, WithStyles<typeof styles> {
  onCancel?: () => void;
  onConfirm?: () => void;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  confirmButtonDisabled?: boolean;
  buttonsContainerStyle?: CSSProperties;
  pageContainerStyle?: CSSProperties;
  annotations?: React.ReactNode;
  isHideBackdrop?: boolean;
  fullScreen?: boolean;
  isPageInModal?: boolean;
}

export const ModalWithButtons = withStyles(styles)((props: ModalWithButtonsProps) => {
  const { t } = useTranslation();
  const {
    onCancel,
    onConfirm,
    confirmButtonLabel = 'Zapisz',
    cancelButtonLabel = 'Anuluj',
    confirmButtonDisabled,
    children,
    buttonsContainerStyle,
    pageContainerStyle,
    annotations,
    ...modalProps
  } = props;

  return (
    <Modal style={{ ...pageContainerStyle }} {...modalProps}>
      {children}
      {(onCancel || onConfirm) && (
        <>
          <Grid>
            <Grid item style={{ textAlign: 'right', marginBottom: '20px', ...buttonsContainerStyle }}>
              {onCancel && (
                <CancelButton
                  onClick={onCancel}
                  onKeyDown={(event: React.KeyboardEvent<HTMLButtonElement>) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      onCancel();
                    }
                  }}
                >
                  {cancelButtonLabel}
                </CancelButton>
              )}
              {onConfirm && (
                <ConfirmButton
                  onClick={onConfirm}
                  disabled={confirmButtonDisabled}
                  onKeyDown={(event: React.KeyboardEvent<HTMLButtonElement>) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      onConfirm();
                    }
                  }}
                >
                  {confirmButtonLabel}
                </ConfirmButton>
              )}
            </Grid>
          </Grid>
          {annotations}
        </>
      )}
    </Modal>
  );
});
